function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 5a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.832 17.445L14.535 14h-5.07l-2.297 3.445 1.664 1.11L10.535 16h2.93l1.703 2.555 1.664-1.11z",
  fill: "#4038FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1118 0 9 9 0 01-18 0z",
  fill: "#4038FF"
});

var SvgCreatorTokens = function SvgCreatorTokens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA1QzkuNzkwODggNSA4LjAwMDAyIDYuNzkwODYgOC4wMDAwMiA5QzguMDAwMDIgMTEuMjA5MSA5Ljc5MDg4IDEzIDEyIDEzQzE0LjIwOTIgMTMgMTYgMTEuMjA5MSAxNiA5QzE2IDYuNzkwODYgMTQuMjA5MiA1IDEyIDVaTTEwIDlDMTAgNy44OTU0MyAxMC44OTU0IDcgMTIgN0MxMy4xMDQ2IDcgMTQgNy44OTU0MyAxNCA5QzE0IDEwLjEwNDYgMTMuMTA0NiAxMSAxMiAxMUMxMC44OTU0IDExIDEwIDEwLjEwNDYgMTAgOVoiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZD0iTTE2LjgzMjEgMTcuNDQ1M0wxNC41MzUyIDE0SDkuNDY0ODRMNy4xNjc5NyAxNy40NDUzTDguODMyMDcgMTguNTU0N0wxMC41MzUyIDE2SDEzLjQ2NDhMMTUuMTY4IDE4LjU1NDdMMTYuODMyMSAxNy40NDUzWiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDFDNS45MjQ4NyAxIDEgNS45MjQ4NyAxIDEyQzEgMTguMDc1MSA1LjkyNDg3IDIzIDEyIDIzQzE4LjA3NTEgMjMgMjMgMTguMDc1MSAyMyAxMkMyMyA1LjkyNDg3IDE4LjA3NTEgMSAxMiAxWk0zIDEyQzMgNy4wMjk0NCA3LjAyOTQ0IDMgMTIgM0MxNi45NzA2IDMgMjEgNy4wMjk0NCAyMSAxMkMyMSAxNi45NzA2IDE2Ljk3MDYgMjEgMTIgMjFDNy4wMjk0NCAyMSAzIDE2Ljk3MDYgMyAxMloiIGZpbGw9IiM0MDM4RkYiLz4KPC9zdmc+Cg==";
export { SvgCreatorTokens as ReactComponent };